import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="heading01 type01">
            <h1>{{ 'manage.Tasklist templates' | translate }}</h1>
            <a class="btn add" ui-sref="authorized.manage.settings.tasklist.templates.add()">
                {{ 'manage.Add tasklist template' | translate }}
            </a>
        </div>
        <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <table class="data01" datatable dt-options="vm.DATATABLES">
                <thead>
                    <tr>
                        <th ng-class="vm.list.getSortClass('name')">
                            <a ng-click="vm.list.sortBy('name')">
                                {{ 'tasklist.Tasklist template name' | translate }}
                            </a>
                        </th>
                        <th ng-class="vm.list.getSortClass('task_count')">
                            <a ng-click="vm.list.sortBy('task_count')">
                                {{ 'tasklist.Tasks' | translate }}
                            </a>
                        </th>
                        <th class="actions">&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items">
                        <td>
                            <a ui-sref="authorized.manage.settings.tasklist.templates.edit({ id: item.id })">
                                {{ item.name }}
                            </a>
                        </td>
                        <td>{{ item.taskCount }}</td>
                        <td class="actions">
                            <a ui-sref="authorized.manage.settings.tasklist.templates.edit({ id: item.id })" class="btn edit">
                                {{ 'general.Edit' | translate }}
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, DATATABLES, ListFactory, TasklistTemplateResource) {
        this.lodash = lodash;
        this.$translate = $translate;
        this.DATATABLES = DATATABLES;
        this.ListFactory = ListFactory;
        this.TasklistTemplateResource = TasklistTemplateResource;
    }

    $onInit () {
        this.list = this.ListFactory.createWithPagination(
            this.TasklistTemplateResource.query.bind(this.TasklistTemplateResource)
        );
        this.list.fetch();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/settings/tasklist/templates/list/index.js